const newtonxColors = {
  amber: {
    50: '#FFF3EB',
    100: '#FFDBC2',
    200: '#FFCFAD',
    300: '#FFB685',
    400: '#FF9E5C',
    500: '#FF8633',
    600: '#CC6B29',
    700: '#99501F',
    800: '#663614',
    900: '#331B0A',
  },
  blue: {
    50: '#F9FBFF',
    100: '#F3F6FF',
    200: '#E7EDFF',
    300: '#9FB7FF',
    400: '#5781FF',
    500: '#0F4BFF',
    600: '#0642F3',
    700: '#0036E6',
    800: '#0028DB',
    900: '#0001CC',
    A100: '#C7CBFF',
    A200: '#91A5FE',
    A300: '#7386FF',
    A700: '#0035D8',
  },
  deepOrange: {
    50: '#FBE9E7',
    100: '#FFCCBC',
    200: '#FFAB91',
    300: '#FF8A65',
    400: '#FF7043',
    500: '#FF5722',
    600: '#F4511E',
    700: '#E64A19',
    800: '#D84315',
    900: '#BF360C',
    A100: '#FF9E80',
    A200: '#FF6E40',
    A400: '#FF3D00',
    A700: '#DD2C00',
  },
  green: {
    50: '#E6F5EB',
    100: '#C3E5CD',
    200: '#9CD5AE',
    300: '#74C58F',
    400: '#54B977',
    500: '#31AD60',
    600: '#2A9E56',
    700: '#208C4A',
    800: '#187B3F',
    900: '#065B2C',
    A100: '#BCDD99',
    A200: '#9FDFB3',
    A400: '#92C46F',
    A700: '#C1CC67',
  },
  grey: {
    50: '#FAFAFA',
    100: '#F4F4F5',
    200: '#EAEAEA',
    300: '#DEDFE0',
    400: '#D4D5D5',
    500: '#BEBFC0',
    600: '#929596',
    700: '#727577',
    800: '#474B4C',
    900: '#262B2D',
    A100: '#F5F5F5',
    A200: '#EEEEEE',
    A400: '#BDBDBD',
    A700: '#616161',
  },
  lightBlue: {
    50: '#F8FDFE',
    100: '#F1FAFC',
    200: '#E4F5F9',
    300: '#D6F0F6',
    400: '#C9EBF3',
    500: '#BBE6F0',
    600: '#96B8C0',
    700: '#708A90',
    800: '#4B5C60',
    900: '#252E30',
  },
  orange: {
    50: '#FFF3E0',
    100: '#FFE0B2',
    200: '#FFCC80',
    300: '#FFB74D',
    400: '#FFA726',
    500: '#FF9800',
    600: '#FB8C00',
    700: '#F57C00',
    800: '#EF6C00',
    900: '#E65100',
    A100: '#FFD180',
    A200: '#FFAB40',
    A400: '#FF9100',
    A700: '#FF6D00',
  },
  red: {
    50: '#FDE3E8',
    100: '#F9BAC6',
    200: '#F48DA1',
    300: '#EE617C',
    400: '#E74162',
    500: '#E12749',
    600: '#D12249',
    700: '#BC1C45',
    800: '#A81543',
    900: '#850A3D',
    A100: '#FF8A80',
    A200: '#FF5252',
    A400: '#FF1744',
    A700: '#D50000',
  },
  teal: {
    50: '#F4FCF8',
    100: '#EAF9F1',
    200: '#D5F3E4',
    300: '#BFECD6',
    400: '#AAE6C9',
    500: '#95E0BB',
    600: '#77B396',
    700: '#598670',
    800: '#3C5A4B',
    900: '#1E2D25',
  },
  gradients: {
    prime: 'linear-gradient(90deg, rgba(15, 75, 255, 0.3), rgba(255, 134, 51, 0.3))',
    background: 'linear-gradient(90deg, rgba(214, 229, 253, 1), rgba(226, 243, 241, 1))',
    background2: 'linear-gradient(90deg, rgba(15, 75, 255, 0.05), rgba(187, 230, 240, 0.4))',
    aiComponent: 'linear-gradient(90deg, rgba(183, 207, 241, 1), rgba(221, 228, 183, 1))',
    line: 'linear-gradient(90deg, rgba(126, 189, 212, 1), rgba(143, 215, 193, 1))',
    aiIcon: 'linear-gradient(90deg, rgba(87, 129, 255, 1), rgba(138, 207, 199, 1))',
    lightBackground:
      'linear-gradient(90deg, rgba(159, 183, 255, 0.05) 0%, rgba(197, 220, 145, 0.05) 52%, rgba(159, 183, 255, 0.05) 100%)',
  },
  action: {
    selected: 'rgba(38, 43, 45, 0.08)',
  },
};

export default newtonxColors;
